import React from "react";
import * as Moment from "moment";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import "../member/member.css";
import {
  format,
  compareAsc,
  startOfDay,
  differenceInDays,
  parseISO,
  parseJSON,
  isDate
} from "date-fns";

// Const
const ACT_TRAINING = "NCDFOapeUK5GsU6PHTBo";
const ACT_INSTRUCTOR = "qw0N72HFzjXJeNQAmCk2";

const ActivityTypeStyles = {
  [ACT_TRAINING]: {
    // "box-shadow": "0px 1px 20px 0px #ffeb00, inset 0px 0px 40px -20px #000000",
    // "background": "#00ff2b"
    "box-shadow": "0px 1px 4px 0px #ffffff, inset 0px 0px 0px 1px #fff",
    // "background": "#00af9e",
    background: "#003271",
    color: "white"
  },
  [ACT_INSTRUCTOR]: {
    "box-shadow": "0px 1px 6px 0px #ca99ff, inset 0px 0px 0px 1px #fff",
    background: "#ef006e",
    color: "white"
  }
};
const ActivityTypeStyles_memberLine = {
  [ACT_TRAINING]: {
    background: "#003271",
    color: "white"
  },
  [ACT_INSTRUCTOR]: {
    background: "#ef006e",
    color: "white"
  }
};

const ActivityMemberStyle = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  font-size: 0.9em;
  /* margin-bottom: 5px; */

  flex: 1 1 auto;
  background: #fff;
  color: #222;
  text-decoration: none;
  padding-left: 14px;
  /* box-shadow: 0px 1px 6px 0px #aaa,  inset 0px 0px 40px 0px #f0f0f0; */
  box-shadow: 0px 1px 6px 0px #bd9a9a, inset 0px 0px 0px 1px #aaa;

  ${({ foundActivityToday }) =>
    foundActivityToday &&
    css(ActivityTypeStyles[foundActivityToday.ActivityTypeId])};

  .member-rank {
    position: absolute;
    height: 100%;
    left: 0px;
    z-index: 10;
    /* box-shadow: 1px 0px 6px 0px #aaa; */
    /* box-shadow: 0px 1px 6px 0px #aaa,  inset 0px 0px 40px 0px #e5e5e5; */
  }

  .member-rank img {
    width: 14px;
    height: 100%;
  }

  a {
    text-decoration: none;
    color: #bbb;
  }

  .member-image-wrapper {
    position: relative;
    width: 55px;
    height: 100%;
    max-height: 70px;
    border-radius: 3px;
    /* border-radius: 50px; */
    overflow: hidden !important;
    /* height: 100%; */
    margin-top: 8px;
    margin-left: 6px;
    /* background: #d8f1ec; */
    background: #eee;
    /* background: #f5f0b6; */
  }

  .member-image-wrapper .image {
    position: absolute;
    max-width: 80px;
    /* height: 100%; */
    margin-top: -8px;
    margin-left: -12px;
    /* box-shadow: 0px -1px 1px 0px #888; */
  }

  .rank {
    height: 20px;
    width: 20px;
    border-radius: 10px;
    overflow: hidden;
  }

  .rank img {
  }
`;

const LinkWrap = styled(Link)`
  cursor: pointer;
  width: 60px;
  /* height: 60px; */
  flex: 0 0 60px;
  overflow: hidden;
  margin-bottom: 4px;
`;

const MemeberWrap = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
`;

const MemberInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  font-size: 16px;
  margin: 6px 2px 4px 6px;
  word-break: break-all;
  width: 100%;

  .title {
    font-weight: bold;
    /* color: #800; */
    padding-bottom: 4px;
    flex: 0 1 auto;
  }

  .rank {
    font-size: 14px;
    flex: 0 1 auto;
    width: 100%;
  }

  .role {
    font-size: 14px;
    flex: 0 1 auto;
    width: 100%;
    /* color: #00a4ca; */
  }
`;

const ActivityWrapper = styled.div`
  background: #031;
  color: white;
  padding: 6px;
  border-radius: 3px;
  width: 120px;
  text-align: center;
`;

const ActivityScoreWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1px 0px 1px 4px;
  flex: 0 0 114px;
`;

const LatestActivityWrapper = styled.div`
  padding: 4px;
  background-color: rgba(0, 0, 0, 0.22);
  justify-content: center;
  /* min-width: 90px; */
  word-break: break-all;
  /* overflow: hidden; */
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;

  ${({ activityTypeId }) =>
    activityTypeId && css(ActivityTypeStyles_memberLine[activityTypeId])};
`;

const LatestActTitle = styled.div`
  font-size: 0.6em;
  text-align: center;
  flex: 1 1 auto;
`;
const LatestActRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const Strong = styled.strong`
  font-size: 1.2em;
`;

const ActivityCountWrapper = styled.div`
  padding: 4px;
  background-color: rgba(0, 0, 0, 0.17);
  justify-content: center;
  /* min-width: 90px; */
  word-break: break-all;
  /* overflow: hidden; */
  flex: 0 0 22px;
  display: flex;
  flex-direction: row;

  ${({ activityTypeId }) =>
    activityTypeId && css(ActivityTypeStyles_memberLine[activityTypeId])};
`;

const ActivityCountTitle = styled.div`
  font-size: 0.6em;
  /* text-align: center; */
  flex: 1 1 auto;
`;
const ActivityCountValue = styled.div`
  /* background-color: rgba(0,0,0,0.1); */
  font-size: 1.1em;
  text-align: right;
  flex: 0 0 40px;
  padding-right: 5px;
  /* margin-left: 2px; */
`;

/***************************************************
 *
 * ActivityMember
 *
 ***************************************************/
const ActivityMember = props => {
  const foundActivityToday =
    props.member.Activities &&
    props.member.Activities.find(act => props.selectedActivityDate == act.Date);

  let trainingCount = 0;
  let instructorCount = 0;
  let scoreSum = 0;
  let latestActivity;
  let latestActivityDate = "";
  let latestActivityInstructor = "";
  props.member.Activities &&
    props.member.Activities.forEach(act => {
      switch (act.ActivityTypeId) {
        case ACT_TRAINING:
          trainingCount++;
          break;
        case ACT_INSTRUCTOR:
          instructorCount++;
          break;
      }
      scoreSum = scoreSum + act.Score;

      const numOfDaysSinsActivity = differenceInDays(
        startOfDay(new Date()),
        startOfDay(new Date(act.Date))
      );
      if (
        !latestActivity ||
        (numOfDaysSinsActivity >= 0 && numOfDaysSinsActivity < latestActivity)
      ) {
        latestActivity = numOfDaysSinsActivity;
        latestActivityDate =
          act.Date.length > 0 ? format(parseISO(act.Date), "dd. MMM yyyy") : "";
        latestActivityInstructor = act.Instructor;
      }
    });

  const totalInstructorCount = instructorCount > 0 && (
    <ActivityCountWrapper activityTypeId={ACT_INSTRUCTOR}>
      <ActivityCountTitle>Instruktør</ActivityCountTitle>
      <ActivityCountValue>{instructorCount}</ActivityCountValue>
    </ActivityCountWrapper>
  );

  const totalTrainingCount = trainingCount > 0 && (
    <ActivityCountWrapper activityTypeId={ACT_TRAINING}>
      <ActivityCountTitle>Træning</ActivityCountTitle>
      <ActivityCountValue>{trainingCount}</ActivityCountValue>
    </ActivityCountWrapper>
  );

  const totalScore = scoreSum > 0 && (
    <ActivityCountWrapper>
      <ActivityCountTitle>Keiken</ActivityCountTitle>
      <ActivityCountValue>{scoreSum}</ActivityCountValue>
    </ActivityCountWrapper>
  );

  const daysSinsLastActivity = latestActivity >= 0 && (
    <LatestActivityWrapper>
      <LatestActTitle>Sidste træning</LatestActTitle>
      <LatestActTitle>
        <Strong>{latestActivityDate}</Strong>
      </LatestActTitle>
      <LatestActTitle>
        <Strong>{latestActivity}</Strong> dage siden
      </LatestActTitle>
      {/* <LatestActRow>
        <ActivityCountTitle>{latestActivityDate}</ActivityCountTitle>
      <ActivityCountValue>{latestActivity}</ActivityCountValue>
    </LatestActRow> */}
      <LatestActTitle>{latestActivityInstructor}</LatestActTitle>
    </LatestActivityWrapper>
  );

  const currentRankImageUrl =
    props.memberRanks[0] && props.memberRanks[0].level
      ? "/" + props.memberRanks[0].level.LevelImage
      : null;

  const currentRankImage =
    props.memberRanks[0] && props.memberRanks[0].level ? (
      <React.Fragment>
        <img className="rank-image" src={currentRankImageUrl} />
      </React.Fragment>
    ) : null;

  const currentRank =
    props.memberRanks[0] && props.memberRanks[0].level ? (
      <>
        {props.member.Title ? <span>{props.member.Title}, </span> : null}{" "}
        {/* <img className="rank" src={currentRankImageUrl} /> */}
        {props.memberRanks[0].level.LevelTitle},{" "}
        <span className="experience">
          {Moment(props.memberRanks[0].RankDate).fromNow()}
        </span>
      </>
    ) : null;

  const memberImage =
    props.member && props.member.ImageUrl ? (
      <div className="member-image-wrapper">
        <img className="image" src={props.member.ImageUrl} />
      </div>
    ) : (
      <div className="member-image-wrapper">
        {/* <img className="image" src={props.member.ImageUrl} /> */}
      </div>
    );

  const memberRole = props.member.Role ? <div>{props.member.Role}</div> : null;
  const memberExtraRole = props.member.ExtraRole ? (
    <div>{props.member.ExtraRole}</div>
  ) : null;

  const memberTagNew =
    props.member.Status && props.member.Status.toLowerCase() == "ny" ? (
      <div className="memberTag new">NY</div>
    ) : null;
  const memberTagReady =
    props.member.Status && props.member.Status.toLowerCase() == "klar" ? (
      <div className="memberTag ready">KLAR</div>
    ) : null;

  return (
    <MemeberWrap>
      <ActivityMemberStyle foundActivityToday={foundActivityToday}>
        {/* <LinkWrap className="member" to={`/member/${props.member.ID}`}> */}
        {memberTagNew}
        {memberTagReady}
        <div className="member-rank">{currentRankImage}</div>
        <LinkWrap to={`/member/${props.member.ID}`}>{memberImage}</LinkWrap>
        <MemberInfo>
          <div className="title">
            {props.member.FirstName}
            &nbsp;
            {props.member.LastName},{" "}
            {Moment().diff(Moment(props.member.Birthdate), "years", false)} år
          </div>
          <div className="rank">{currentRank}</div>
          <div className="role">
            {memberRole}
            {memberExtraRole}
            {props.member.TeamName}
          </div>
        </MemberInfo>
        <ActivityScoreWrapper>
          {totalInstructorCount}
          {totalTrainingCount}
          {totalScore}
          {daysSinsLastActivity}
        </ActivityScoreWrapper>
        {/* <Link className="editUser" to={`/edit/member/${props.member.ID}`}>
          🖊
          </Link> */}
      </ActivityMemberStyle>
      {/* </LinkWrap> */}
    </MemeberWrap>
  );
};

export default ActivityMember;
